export const MONITORING_FQN = 'fqn';
export const MONITORING_INCLUDE_SUBFOLDERS = 'includeSubfolders';
export const MONITORING_TIME_FRAME = 'timeFrameMinutes';
export const MONITORING_ENVIRONMENT_ID = 'environmentId';
export const MONITORING_ROBOT_TYPE = 'robotType';
